import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/components/common/base/homePage'
import VueScrollbar from 'vue2-scrollbar'
//登录页面
import Login from '@/components/moudle/Login/login'
import Error from '@/components/moudle/Login/error'

import Transition from '@/components/moudle/Login/entryPage'

import EntryPage from '@/components/moudle/Login/entryPage'
import EQPage from '@/components/moudle/Login/EQPage'
//资料中心
import HospitalImage from '@/components/moudle/hospitalImage/hospitalImage'
import MedicalRecord from '@/components/moudle/medicalRecord/medicalRecord'
import queryMedicalRecordInfo from '@/components/moudle/medicalRecord/queryMedicalRecordInfo'
import newMedicalRecord from '@/components/moudle/medicalRecord/newMedicalRecord'
import CourseWare from '@/components/moudle/courseWare/courseWare'
import AddCourseWare from '@/components/moudle/courseWare/addCourseWare'
import QuerycourseWareInfo from '@/components/moudle/courseWare/querycourseWareInfo'
import ViewReport from '@/components/moudle/hospitalImage/viewReport'
import zerReport from '@/components/common/report/zerReport/'
//会议管理
import DailyMeeting from '@/components/moudle/dailyMeeting/dailyMeeting'//每日读片
import DailyDetail from '@/components/moudle/dailyMeeting/dailyDetail'
import ManageMeeting from '@/components/moudle/manageMeeting/manageMeeting'//专题读片
import AddManageMeeting from '@/components/moudle/manageMeeting/addManageMeeting'//新增会议
import QueryManageMeeting from '@/components/moudle/manageMeeting/queryManageMeeting'//专题读片查看
import EnterManageMeeting from '@/components/moudle/manageMeeting/enterManageMeeting' //
//教学管理
import TeachManage from '@/components/moudle/teachManage/teachManage'
import NewCourse from '@/components/moudle/teachManage/newCourse'
import LookCourse from '@/components/moudle/teachManage/lookCourse'
//教学中心
import TeachCenter from '@/components/moudle/teachCenter/teachCenter'
import TeachDetail from '@/components/moudle/teachCenter/TeachDetail'
import CourseEvaluat from '@/components/moudle/teachCenter/courseEvaluat'
import teachRoom from '@/components/moudle/teachRoom/teachRoom'
//阅片
import ImgView from '@/components/common/base/imgView'
//帮助
import Help from '@/components/common/help/help'
import Software from '@/components/moudle/Software/Software'
import RunEnvironment from '@/components/moudle/RunEnvironment/RunEnvironment'
import Audio from '@/components/moudle/Audio/Audio'
import UserMessage from '@/components/moudle/UserMessage/UserMessage'
import ImageHospital from '@/components/moudle/ImageHospital/ImageHospital'
import TypicalBank from '@/components/moudle/ImageHospital/TypicalBank'
import TeachWare from '@/components/moudle/ImageHospital/TeachWare'
import DailyReading from '@/components/moudle/DailyReading/DailyReading'
import ManageTeach from '@/components/moudle/ManageTeach/ManageTeach'
import ThematicReading from '@/components/moudle/DailyReading/ThematicReading'
import ExcellentCourse from '@/components/moudle/ExcellentCourse/ExcellentCourse'
import ThematicRead  from '@/components/moudle/ExcellentCourse/ThematicRead'
import MyCollection from '@/components/moudle/ExcellentCourse/MyCollection'
import Mylearn from '@/components/moudle/ExcellentCourse/Mylearn'

//关于
import About from '@/components/common/about/about'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
    path: '/login',
    name: 'Login',
    component: Login,

  },
  {
    path: '/EQPage',
    name: 'EQPage',
    component: EQPage ,
  },
   {
    path: '/Error',
    name: 'Error',
    component: Error,
  }, {
    path: '/teachRoom',
    name: 'teachRoom',
    component: teachRoom,
  },{
    path: '/ImgView',
    name: 'ImgView',
    component: ImgView,
  },
  {
    path: '/HospitalImage/ViewReport/zerReport',
    name: 'zerReport',
    component: zerReport
  }, {
    path: '/Transition',
    name: 'Transition',
    component: Transition,
    redirect: '/Homepage/EntryPage',

  }, {
    path: '/Homepage',
    name: 'Homepage',
    component: Homepage,
    redirect: '/Homepage/HospitalImage',
    children: [{
      path: 'EntryPage',
      name: 'EntryPage',
      component: EntryPage,
    }, {
      path: 'HospitalImage',
      name: 'HospitalImage',
      component: HospitalImage,
    }, {
      path: 'HospitalImage/ViewReport',
      name: 'ViewReport',
      component: ViewReport
    }, {
      path: 'MedicalRecord',
      name: 'MedicalRecord',
      component: MedicalRecord,
      children: [{
        path: 'queryMedicalRecordInfo/:id',
        name: 'queryMedicalRecordInfo',
        component: queryMedicalRecordInfo,
      }, {
        path: 'newMedicalRecord',
        name: 'newMedicalRecord',
        component: newMedicalRecord
      }, {
        path: 'updateMedicalRecord/:id',
        name: 'updateMedicalRecord',
        component: newMedicalRecord
      }]
    }, {
      path: 'CourseWare',
      name: 'CourseWare',
      component: CourseWare,
      children: [{
        path: 'AddCourseWare',
        name: 'AddCourseWare',
        component: AddCourseWare
      }, {
        path: 'ModifyCourseWare',
        name: 'ModifyCourseWare',
        component: AddCourseWare
      }, {
        path: 'QuerycourseWareInfo',
        name: 'QuerycourseWareInfo',
        component: QuerycourseWareInfo
      }]
    }, {
      path: 'DailyMeeting',
      name: 'DailyMeeting',
      component: DailyMeeting,
    }, {
      path: 'DailyMeeting/DailyDetail',
      name: 'DailyDetail',
      component: DailyDetail,
    }, {
      path: 'ManageMeeting',
      name: 'ManageMeeting',
      component: ManageMeeting,
      children: [{
        path: 'AddManageMeeting',
        name: 'AddManageMeeting',
        component: AddManageMeeting
      }, {
        path: 'ModifyManageMeeting',
        name: 'ModifyManageMeeting',
        component: AddManageMeeting
      }, {
        path: 'QueryManageMeeting',
        name: 'QueryManageMeeting',
        component: QueryManageMeeting
      }, {
        path: 'EnterManageMeeting',
        name: 'EnterManageMeeting',
        component: EnterManageMeeting
      }]
    }, {
      path: 'TeachManage',
      name: 'TeachManage',
      component: TeachManage,
      children: [{
        path: 'NewCourse',
        name: 'NewCourse',
        component: NewCourse
      }, {
        path: 'LookCourse',
        name: 'LookCourse',
        component: LookCourse
      }]
    }, {
      path: 'TeachCenter',
      name: 'TeachCenter',
      component: TeachCenter,
      children: [{
        path: 'CourseEvaluat',
        name: 'CourseEvaluat',
        component: CourseEvaluat
      }, {
        path: 'TeachDetail',
        name: 'TeachDetail',
        component: TeachDetail
      }]
    },
  ]
  },
  {
  path:'/About',
  name:'About',
  component:About
  },
  {
    path: '/Help',
    name: 'Help',
    component: Help,
    redirect: '/Help/Software',
    children:[{
        path:'Software',
        name:'Software',
        component:Software

    },
    {
      path:'Audio',
      name:'Audio',
      component:Audio
    },
    {
      path:'ManageTeach',
      name:'ManageTeach',
      component:ManageTeach,
    },
    {
      path:'RunEnvironment',
      name:'RunEnvironment',
      component:RunEnvironment
    },
    {
      path:'UserMessage',
      name:'UserMessage',
      component:UserMessage
    },
    {
      path: 'ImageHospital',
      name: 'ImageHospital',
      component: ImageHospital,
    }, {
      path: 'TypicalBank',
      name: 'TypicalBank',
      component: TypicalBank,
    },
     {
       path:'TeachWare',
       name: 'TeachWare',
       component: TeachWare,
     },
     {
       path:'DailyReading',
       name: 'DailyReading',
       component: DailyReading,
     },
     {
      path:'ThematicReading',
      name: 'ThematicReading',
      component: ThematicReading,
    },
     {
       path:'ExcellentCourse',
       name: 'ExcellentCourse',
       component: ExcellentCourse,
     },
     {
      path:'ThematicRead',
      name: 'ThematicRead',
      component: ThematicRead,
    },
    {
      path:'MyCollection',
      name: 'MyCollection',
      component: MyCollection,
    },
    {
      path:'Mylearn',
      name: 'Mylearn',
      component: Mylearn,
    },

  ]
  },
  ]
})



//////////////////
// WEBPACK FOOTER
// ./router/index.js
// module id = 22
// module chunks = 1 2 3 4 5 6 7 8